// extracted by mini-css-extract-plugin
module.exports = {"PageLoading":"PageLoading___2zejk","logo":"logo___1nbnO"};